import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import { Grid } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
import DropDownMultiple from '../../../../Components/DropDownMultiple';
import ArrayInputConfig from '../../../../Components/ArrayInputConfig';
import { countryCodesList } from '../../../../core/constants';
import { MANUAL_FLOOR_KEYS } from '../../constants';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import useCommonStyles from '../../../../commonStyles';
const { MANUAL_FLOOR_RULES_KEY, COUNTRY, AD_UNITS, PLATFORM, FLOOR } = MANUAL_FLOOR_KEYS;

const ManualFloorRuleCard = ({ manualFloorRuleObj, deleteManualFloorRuleObj, index }) => {
	const { bannerFpConfig, updateBannerFpConfig } = useContext(BannerFpContext);
	const commonStyleClasses = useCommonStyles();
	const updateManualFloorRule = (key, updatedValue, obj) => {
		const clonedBannerFpConfig = structuredClone(bannerFpConfig);
		const clonedManualFloorRule = clonedBannerFpConfig[MANUAL_FLOOR_RULES_KEY][index];
		clonedManualFloorRule[key] = updatedValue;
		updateBannerFpConfig(clonedBannerFpConfig);
	};

	return (
		<Grid
			item
			xs={12}
			className={commonStyleClasses.basicOutlinedBox}
			style={{ marginBottom: '2rem' }}
		>
			<Grid container spacing={1}>
				<Grid item xs={3}>
					<DropDownMultiple
						isObjectEditor={false}
						directValue={manualFloorRuleObj[COUNTRY] || []}
						updateDirectValue={(newVal) => updateManualFloorRule(COUNTRY, newVal)}
						list={countryCodesList}
						label="Countries"
					/>
				</Grid>
				<Grid item xs={3}>
					<DropDownMultiple
						isObjectEditor={false}
						directValue={manualFloorRuleObj[PLATFORM] || []}
						updateDirectValue={(newVal) => updateManualFloorRule(PLATFORM, newVal)}
						list={['DESKTOP', 'MOBILE', 'TABLET', 'DEFAULT']}
						label="Platform"
					/>
				</Grid>

				<Grid item xs={3}>
					<InputConfig
						isObjectEditor={false}
						directValue={manualFloorRuleObj[FLOOR]}
						updateDirectValue={(newVal) => updateManualFloorRule(FLOOR, newVal)}
						inputType="number"
						label="Floor"
						inputStyles={{ width: '100%', marginTop: 0 }}
					/>
				</Grid>
				<Grid item xs={12}>
					<ArrayInputConfig
						isObjectEditor={false}
						directValue={manualFloorRuleObj[AD_UNITS] || []}
						updateDirectValue={(newVal) => updateManualFloorRule(AD_UNITS, newVal)}
						label="Ad Units"
						inputContainerStyle={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}
						inputGridStyle={{ display: 'flex' }}
					/>
				</Grid>
				<Grid item xs={12} style={{ marginTop: '2rem' }}>
					<DeleteOutlinedIcon
						color="primary"
						onClick={() => deleteManualFloorRuleObj(index)}
						className={commonStyleClasses.icon}
					/>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ManualFloorRuleCard;
